<!-- PRODUCT LIST -->
<ng-container *ngIf="displayType === 'LIST'">
    <ng-container [ngTemplateOutlet]="productEmpty" [ngTemplateOutletContext]="{ products: products }"></ng-container>
    <!-- ProdList -->
    <ul class="ProdList">
        <ng-container *ngFor="let product of pagination ? (products | paginate : config) : products">
            <li [product]="product"></li>
        </ng-container>
    </ul>
    <paging class="vh-100" *ngIf="pagination && total > len" [len]="len" [page]="page" [config]="config" [totalItems]="total"
        (changePage)="onChangePage($event)" (changeLen)="onChangeLen($event)" [turnOnLenOptions]="lenOption"
        [turnOnPagination]="pagination" [turnOnTotalItem]="totalItem"></paging>
</ng-container>

<ng-template #productEmpty let-products="products">
    <ng-container *ngIf="
			products === undefined || products === null || products.length === 0
		">
        <ng-container *ngIf="currentUrl != urlHomePage">
            <div class="empty-products h-small">
                <span>We're updating products. Please come back later.</span>
            </div>
        </ng-container>
    </ng-container>
</ng-template>
